import React from "react";
import { Link } from "react-router-dom";
import classes from "./BlogItem.module.css";
import { useBlogItem } from "../../Pregrine/BlogItem/useBlogItem";

const BlogItem = (props) => {
  const talonProps = useBlogItem(props);
  const { blogItem, day, month, year, isMobile } = talonProps;

  return (
    <>
      <div
        className={`item ${isMobile() ? classes.card : classes.border_right}`}
      >
        <div className="row align-items-center">
          <Link to={`/blog/${blogItem.url_key}`}>
            <div className="imgblog">
              <img
                className={classes.pull_right}
                src={blogItem.image}
                alt="..."
              />
            </div>
          </Link>

          <div className={classes.blog_details}>
            <p className={classes.time}>
              {month} {day}, {year}
            </p>
            <Link
              style={{ textTransform: "none" }}
              to={`/blog/${blogItem.url_key}`}
            >
              <h5>{blogItem && blogItem.name}</h5>
            </Link>

            <p>
              {blogItem.short_description &&
              blogItem.short_description.length > 150
                ? `${blogItem.short_description.slice(0, 120)}...`
                : blogItem.short_description}
            </p>

            <Link to={`/blog/${blogItem.url_key}`}>Read More</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogItem;
